import { render, staticRenderFns } from "./EditVipPlan.vue?vue&type=template&id=95ad1a2c"
import script from "./EditVipPlan.vue?vue&type=script&lang=js"
export * from "./EditVipPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports